import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_20: FaireProductEntity = {
  token: "toysmith-20",
  type: "product",
  name: "Gayla Flapper Kites",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/61c2b73d74aa1976e41649b9a7fd9a903c794e7075a5a5e9fcecc7b5652f2336.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 10,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
